const DEFAULT_OPTIONS = {
  maxWidth: 1600,
  maxHeight: 1200,
  maxSizeBytes: 1.5 * 1024 * 1024,
  initialQuality: 0.82,
  minQuality: 0.5,
  outputType: 'image/webp',
};

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    const url = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Não foi possível ler a imagem selecionada.'));
    };
    image.src = url;
  });

const canvasToBlob = (canvas, type, quality) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return reject(new Error('Não foi possível comprimir a imagem.'));
        resolve(blob);
      },
      type,
      quality
    );
  });

const getTargetSize = (width, height, maxWidth, maxHeight) => {
  const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
  return {
    width: Math.round(width * ratio),
    height: Math.round(height * ratio),
  };
};

export const compressImageFile = async (file, options = {}) => {
  if (!file || !file.type?.startsWith('image/')) return file;

  const settings = { ...DEFAULT_OPTIONS, ...options };
  const image = await loadImage(file);
  const size = getTargetSize(image.naturalWidth, image.naturalHeight, settings.maxWidth, settings.maxHeight);

  const canvas = document.createElement('canvas');
  canvas.width = size.width;
  canvas.height = size.height;

  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0, size.width, size.height);

  let quality = settings.initialQuality;
  let blob = await canvasToBlob(canvas, settings.outputType, quality);

  while (blob.size > settings.maxSizeBytes && quality > settings.minQuality) {
    quality = Math.max(settings.minQuality, quality - 0.08);
    blob = await canvasToBlob(canvas, settings.outputType, quality);
  }

  if (blob.size >= file.size && file.size <= settings.maxSizeBytes && file.type === settings.outputType) return file;

  const name = file.name.replace(/\.[^.]+$/, '') || 'imagem';
  const extension = settings.outputType === 'image/png' ? 'png' : settings.outputType === 'image/webp' ? 'webp' : 'jpg';
  return new File([blob], `${name}.${extension}`, { type: settings.outputType, lastModified: Date.now() });
};
